import React from "react";
import { CustomInput, Badge, Collapse } from "reactstrap";
import classnames from "classnames";
import { Colxx } from "../../../components/common/CustomBootstrap";
import { END_POINT } from "../../../constants/defaultValues";
import STATUS from "../../../constants/status";
import IntlMessages from "../../../helpers/IntlMessages";
import ProductImage from "../../../components/common/ProductImage";

const ThumbListView = ({
  order,
  isSelect,
  collect,
  onCheckItem,
  underLine,
}) => {
  // console.log('order: ', order);
  // const size = order.size && order.size.split(',');
  // const sizeValue = size.length && size[1] != '0' ? size[0] : '';
  const toppings = order.topping.split("|");

  return (
    <div className="mb-3">
      <span
        onClick={(event) => onCheckItem(event, order.id)}
        className={classnames("mb-2 d-flex flex-row disable-text-selection", {
          active: isSelect,
        })}
      >
        <section className="d-block position-relative">
          <ProductImage
            image={order.product.image}
            alt={order.name}
            fnbType={order.product.fnb_type}
            className="list-thumbnail medium border-0"
            iconSize="40px"
            style={{ width: "120px", height: "90px", objectFit: "cover" }}
          />
          <Badge
            className="position-absolute badge-top-right"
            color={
              order.status.uuid === STATUS.CREATED
                ? "danger"
                : order.status.uuid === STATUS.CLOSED
                  ? "secondary"
                  : order.status.uuid === STATUS.COMPLETED
                    ? "success"
                    : "primary"
            }
            pill
          >
            {order.status.name}
          </Badge>
        </section>
        <div className="card-body-custom d-flex flex-column justify-content-between min-width-zero">
          <section>
            {/* <sup className='text-primary fz-sub'>
                            {order.user_identify}
                        </sup> */}
            <span className="list-item-heading">{order.product.name}</span>
            <br />
            {/* <span className="text-muted text-small mb-1">{order.note ? <span>&#187; {order.note}</span> : <br />}</span> */}
            {/* <div className='pr-4'>
                            <p className='text-muted mb-1 text-small'>
                                {'Số lượng: ' + order.count}
                            </p>
                        </div> */}
            <div className="text-primary text-small font-weight-medium d-sm-block">
              {order.date + " - " + order.time}
            </div>
          </section>
          <div className="w-100">
            {order.size === "" || order.size.split(",")[1] === "0" ? null : (
              <Badge className="mr-1 mt-1" color="warning">
                {order.size.split(",")[0]}
              </Badge>
            )}
            {order.flavor ? (
              <Badge className="mr-1 mt-1" color="info">
                Vị: {order.flavor.split(",")[0]}
              </Badge>
            ) : null}
            {order.ice === "" || order.ice === "100" ? null : (
              <Badge className="mr-1 mt-1" color="primary">
                Đá: {order.ice}%
              </Badge>
            )}
            {order.sugar === "" || order.sugar === "100" ? null : (
              <Badge className="mr-1 mt-1" color="info">
                Độ ngọt: {order.sugar}%
              </Badge>
            )}
            {order.topping === "" || order.topping.split(",")[1] === "0"
              ? null
              : toppings.map((_topping, idx) => (
                  <Badge color="success" className="mr-1 mt-1" key={idx}>
                    {_topping.split(",")[0]}
                  </Badge>
                ))}
          </div>
        </div>
        <div className="custom-control custom-checkbox pl-1 align-self-center">
          <CustomInput
            className="item-check mb-0"
            type="checkbox"
            id={`table_order_${order.id}`}
            checked={isSelect}
            onChange={(event) => onCheckItem(event, order.id)}
            label=""
          />
        </div>
      </span>
      {/* <Collapse
                isOpen={true}
                className={classnames({
                    'custom-line-bottom':
                        underLine &&
                        (order.size ||
                            order.topping ||
                            order.ice ||
                            order.sugar ||
                            order.note),
                })}
            >
                {sizeValue ? (
                    <div className='mb-2'>
                        {order.product.sizeTitle ? (
                            <span>{order.product.sizeTitle}</span>
                        ) : (
                            <IntlMessages id='product.size' />
                        )}
                        {': '}
                        <span>
                            <Badge>{`${sizeValue}`}</Badge>
                        </span>
                    </div>
                ) : null}

                {order.topping ? (
                    <div className='mb-2'>
                        {order.product.toppingTitle ? (
                            <span>{order.product.toppingTitle}</span>
                        ) : (
                            <IntlMessages id='product.topping' />
                        )}
                        {': '}
                        <ToppingComponent data={order.topping} />
                    </div>
                ) : null}

                {order.ice && order.ice != '100' ? (
                    <div className='mb-2'>
                        {order.product.iceTitle ? (
                            <span>{order.product.iceTitle}</span>
                        ) : (
                            <IntlMessages id='product.ice' />
                        )}
                        {': '}
                        <span>
                            <Badge>{`${order.ice} %`}</Badge>
                        </span>
                    </div>
                ) : null}

                {order.sugar && order.sugar != '100' ? (
                    <div className='mb-2'>
                        {order.product.sugarTitle ? (
                            <span>{order.product.sugarTitle}</span>
                        ) : (
                            <IntlMessages id='product.sugar' />
                        )}
                        {': '}
                        <span>
                            <Badge>{`${order.sugar} %`}</Badge>
                        </span>
                    </div>
                ) : null}

                {order.note ? (
                    <div className='mb-2'>
                        <span>{`Ghi chú: `}</span>
                        <span className='red text-small'>{order.note}</span>
                    </div>
                ) : null}
            </Collapse> */}
    </div>
  );
};

export default React.memo(ThumbListView);

const ToppingComponent = (props) => {
  const toppings = props.data.split("|");

  return toppings.length ? (
    <span>
      {toppings.map((_topping, idx) => (
        <Badge className="spacer-5" key={idx}>
          {_topping.split(",")[0]}
        </Badge>
      ))}
    </span>
  ) : null;
};

const SizeComponent = (props) => {
  const size = props.data.split(",");

  return size.length && size[1] != "0" ? (
    <span>
      <Badge>{size[0]}</Badge>
    </span>
  ) : null;
};
